export enum LPRSharingDataScope {
  OWN = 'own',
  SHARED = 'shared',
  ALL = 'all',
}
